var colors = require('../colors');

module['exports'] = (function () {
  var available = ['underline', 'inverse', 'grey', 'yellow', 'red', 'green', 'blue', 'white', 'cyan', 'magenta'];
  return function(letter, i, exploded) {
    return letter === " " ? letter : colors[available[Math.round(Math.random() * (available.length - 1))]](letter);
  };
})();


/*****************
 ** WEBPACK FOOTER
 ** ./~/colors/lib/maps/random.js
 ** module id = 113
 ** module chunks = 0
 **/